import { render, staticRenderFns } from "./format-selector.vue?vue&type=template&id=c45c29a2&"
import script from "./format-selector.vue?vue&type=script&lang=js&"
export * from "./format-selector.vue?vue&type=script&lang=js&"
import style0 from "./format-selector.vue?vue&type=style&index=0&id=c45c29a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports